const Values = () => {
  return (
    <div id="values">
      <h1 className="display-2">Our Values</h1>
      <span className="valuesphere lead"></span>
    </div>
  );
};

export default Values;
